import { configureStore } from '@reduxjs/toolkit';
import carouselReducer from '../features/carousel/carouselSlice';
import productsReducer from '../features/products/productsSlice';
import cartReducer from '../store/slices/cartSlice';

export const store = configureStore({
  reducer: {
    carousel: carouselReducer,
    products: productsReducer,
    cart: cartReducer,
  },
});
